var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabs-container" }, [
    _c(
      "div",
      { staticClass: "main-tabs" },
      _vm._l(_vm.mainTabs, function(tab, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "tab",
            class: { selected: index === _vm.activeTab },
            on: {
              click: function($event) {
                return _vm.changeTab(index)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(tab.label))])]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tabs-separator" }, [
      _vm.objectsTabs.length > 0 ? _c("span", [_vm._v("/")]) : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "objects-tabs" },
      _vm._l(_vm.objectsTabs, function(tab, index) {
        return _c(
          "div",
          {
            key: index + 2,
            staticClass: "tab",
            class: { selected: index === _vm.activeTab - 2 },
            on: {
              click: function($event) {
                return _vm.changeTab(index + 2)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(tab.label))])]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c29d16f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c29d16f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/TasksManagement/TasksManagementTabs.vue
// module id = null
// module chunks = 